import React from "react";
import { Navigate } from "react-router-dom";

export default function RequireAdmin({ children }) {
  const token = localStorage.getItem("neev-auth-token");
  const role = localStorage.getItem("neev-auth-role");

  if (!token || !["admin", "superadmin"].includes(role)) {
    return <Navigate to="/admin-login" replace />;
  }

  return children;
}
